// extracted by mini-css-extract-plugin
export default {"root":"TopicChip-module__root"};